import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormService } from '@core/services';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.scss']
})
export class PasswordComponent implements OnInit {

  @Input() titleText: string;
  @Input() btnText: string;

  @Input()
  get loading(): boolean {
    return this._loading;
  }

  set loading(value: boolean) {
    this._loading = value;
  }

  @Input()
  set serverErrors(errors) {
    if (errors) {
      this.formService.serverValidateForm(this.passwordForm, errors, this.errorMap);
    }
  }

  @Output() serverErrorsChange = new EventEmitter();

  @Output() onSubmit = new EventEmitter();

  _loading = false;

  errorMap = {
    phone_number: 'phone',
    password: 'password'
  };

  passwordForm: FormGroup;
  hidePassword = true;

  constructor(
    public form: FormBuilder,
    public formService: FormService,
  ) { }

  ngOnInit() {
    this.buildForm();
  }

  public buildForm() {
    this.passwordForm = this.form.group({
      phone: [null, [Validators.required]],
      password: [null,
        [
          Validators.required,
          Validators.maxLength(16),
          Validators.pattern('(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$'),
        ],

      ],
      rememberMe: [false]
    });
  }


  ngAfterViewInit() {
    fromEvent<KeyboardEvent>(document, 'keyup')
      .pipe(
        filter((e: KeyboardEvent) => e.key === 'Enter')
      )
      .subscribe(() => this.submit());
  }

  submit() {
    this._loading = true;

    this.formService.markFormGroupTouched(this.passwordForm);

    if (this.passwordForm.invalid) {
      return this._loading = false;
    }

    this.onSubmit.emit(
      {
        phone: this.passwordForm.controls.phone.value,
        password: this.passwordForm.controls.password.value,
        rememberMe: this.passwordForm.controls.rememberMe.value
      });
  }

}
